import { alpha, useTheme } from '@mui/material/styles';
import TileIconBadge from './tile-icon-badge';
import { CommandDashboardTileDefinition } from './tile-config';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

interface TileDropPreviewProps {
  tile: CommandDashboardTileDefinition;
}

// A preview of a tile being dragged in from the library
export default function TileDropPreview({ tile }: TileDropPreviewProps) {
  const theme = useTheme();

  return (
    <Box
      data-testid="tile-drop-preview"
      sx={{
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '2px dashed',
        borderColor: theme.palette.primary.main,
        borderRadius: '8px',
        bgcolor: alpha(theme.palette.primary.main, 0.08),
        // The pointer is mid-drag, so nothing here should intercept it and
        // stop the dragover events that keep the preview in step.
        pointerEvents: 'none',
      }}
    >
      <Stack direction="row" spacing={1.5} alignItems="center" sx={{ p: 2 }}>
        <TileIconBadge tile={tile} size={24} />
        <Typography
          variant="h6"
          sx={{ color: theme.palette.semantic.text.support }}
        >
          {tile.title}
        </Typography>
      </Stack>
    </Box>
  );
}
